// eslint-disable-next-line import/prefer-default-export
export const transformData = (shipments) => (
  shipments ? shipments.map((shipment) => ({
    ...shipment,
    receiverName: shipment.receiver,
    discountValue: shipment.returnValue || 0,
    valueCollection: shipment.valueCollection,
  })) : []
);
